import React from 'react';
import styled from 'styled-components';
import { Colors } from 'planoplan-ui-kit/core/colors';

export const PageTitle = ({ username, title, avatar }) => (
  <Container>
    <Avatar image={avatar} />
    <Text>
      <UserName>{username}</UserName>
      <Title>{title}</Title>
    </Text>
  </Container>
);

const Container = styled.div`
  display: flex;
  height: 48px;
  color: ${Colors.coal};
`;

const Text = styled.div`
  margin-left: 20px;
`;

const UserName = styled.div`
  font-size: 18px;
  font-weight: 300;
  font-style: normal;
  font-stretch: normal;
  line-height: 0.9;
  letter-spacing: normal;
  overflow: hidden;
  text-overflow: ellipsis;
  white-space: nowrap;
`;

const Title = styled.h1`
  font-size: 28px;
  font-weight: 500;
  font-style: normal;
  font-stretch: normal;
  line-height: 1.4;
  letter-spacing: normal;
  overflow: hidden;
  text-overflow: ellipsis;
  white-space: nowrap;
  margin: 0;
  padding: 0;
`;

const Avatar = styled.div`
  width: 48px;
  height: 48px;
  background-color: ${Colors.light_gray};
  border-radius: 4px;
  background-image: ${(p) => (p.image ? `url(${p.image})` : 'none')};
  background-position: center center;
  background-repeat: no-repeat;
  background-size: cover;
`;
